// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
// import { setothercharges } from "../features/POS";
// import {
//   CustomerInput_Onchange,
//   Input_Onchange,
//   Select_ReturnProduct,
// } from "../features/Transactionstates";
// import Calculation from "./Calculation";
// import { API_FETCH } from "../General/Utility";

// const toNum = (v) => {
//   const n = Number(v);
//   return Number.isFinite(n) ? n : 0;
// };
// const money = (v) => toNum(v).toFixed(2);
// // Same rule System.Text.Json uses for the server's camelCase output
// // (SNo -> sNo, SACCode -> sacCode, ProName -> proName, FQty -> fQty), so rows created
// // here have exactly the keys of rows opened from the server (grid, edit, save).
// const camelKey = (k) => {
//   if (!k || !/[A-Z]/.test(k[0])) return k;
//   const c = k.split("");
//   for (let i = 0; i < c.length; i++) {
//     if (i === 1 && !/[A-Z]/.test(c[1])) break;
//     if (i > 0 && i + 1 < c.length && !/[A-Z]/.test(c[i + 1])) break;
//     c[i] = c[i].toLowerCase();
//   }
//   return c.join("");
// };

// function ProductReturn(props) {
//   const dispatch = useDispatch();
//   const _AuthParems = useSelector((state) => state.Common.Admin);

//   const [arrEntPermission, setarrEntPermission] = useState([]);
//   const [arrEntProduct, setarrEntProduct] = useState([]);
//   const [arrEntCust, setarrEntCust] = useState([]);
//   const [arrEntService, setarrEntService] = useState([]);
//   const [isLoaded, setisLoaded] = useState(false);
//   const busyRef = useRef(false);
//   const closeRef = useRef(props.Close);
//   closeRef.current = props.Close;

//   //#region  Readonly Parem from Global Redux Storage
//   // The POS screen reads Transstates (Header / Data / Summary / Customer), so the
//   // return must be written there. Legacy features/POS only keeps Pos config,
//   // BillDiscount and OtherCharges, which Pointofsales.js still uses.
//   const _Pos = useSelector((state) => state.Pointofsales.Pos);
//   const _Common = useSelector((state) => state.Transstates.Common);
//   const _Data = useSelector((state) => state.Transstates.Data);
//   const _Disc = useSelector((state) => state.Pointofsales.BillDiscount);
//   const _Service = useSelector((state) => state.Pointofsales.OtherCharges);
//   //#endregion

//   useEffect(() => {
//     Load_PosReturn(props.VouchId);
//     // FIX: listener is now removed on unmount (earlier it leaked and every
//     // Escape called Close() once per time the popup had ever been opened).
//     const onKey = (e) => {
//       if (e.key === "Escape") {
//         e.preventDefault();
//         if (closeRef.current) closeRef.current();
//       }
//     };
//     document.addEventListener("keydown", onKey);
//     return () => document.removeEventListener("keydown", onKey);
//     // eslint-disable-next-line
//   }, []);

//   const Load_PosReturn = async (Vouchid) => {
//     try {
//       Pre_Loading(dispatch, true);
//       // FIX: endpoint is [HttpGet] in POSController - was called with API_POST
//       // (and dispatch was passed as the body) => 405 / empty popup.
//       const res = await API_FETCH(
//         `POS/View_ReturnProduct/${Vouchid}/${_AuthParems.DB}`,
//         dispatch
//       );
//       if (res && res.EntReturn && res.EntReturn.entProduct) {
//         setarrEntCust(res.EntReturn.entParty || []);
//         setarrEntService(
//           (res.EntService && res.EntService._EntServiceTax) || []
//         );
//         Assign_ReturnProduct(res.EntReturn.entProduct);
//         let EntCol = [...(res.EntTableCol || [])].sort(
//           (a, b) => a.inOrderTO - b.inOrderTO
//         );
//         EntCol = EntCol.filter((dt) => dt.isShowInScr === true);
//         setarrEntPermission(EntCol);
//       }
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       // FIX: loader was never switched off on the success path.
//       Pre_Loading(dispatch, false);
//       setisLoaded(true);
//     }
//   };

//   const Assign_ReturnProduct = (Returnproduct) => {
//     const TransDT = Returnproduct.map((item, Index) => ({
//       VouchId: item.vouchId,
//       VouchNo: item.vouchNo,
//       VouchDate: item.vouchDate,
//       SNo: item.sNo,
//       ProId: item.proId,
//       AttGrpId: item.attGrpId,
//       ProCode: item.proCode,
//       ProName: item.proName,
//       CommodityCode: item.commodityCode,
//       AttValues: item.attValues || "",
//       UnitId: item.unitId,
//       UnitName: item.unitName,
//       RateWithoutTax: item.rateWithoutTax,
//       RateWithTax: item.rateWithTax,
//       dMinMargin: item.minMargin,
//       ItemDiscPer: item.itemDiscPer,
//       ItemDiscAmt: item.itemDiscAmt,
//       ItemDiscValue: item.itemDiscValue,
//       Qty: item.qty,
//       // ---- used only by this popup (return-qty editing) ----
//       MaxQty: toNum(item.qty),
//       OrigDiscValue: toNum(item.itemDiscValue),
//       OrigNetAmt: toNum(item.netAmt),
//       // ------------------------------------------------------
//       FQty: 0,
//       GoodsValue: item.qty * item.rateWithoutTax,
//       TaxableAmt: 0,
//       TaxAmt: 0,
//       ItemAmt: 0,
//       BatchNo: item.batchNo,
//       ManufactureDate: item.manufactureDate,
//       ExpiryDate: item.expiryDate,
//       iTaxRelId: item.taxRelId,
//       TaxPer: item.igstPer,
//       iSGST: item.sgstId,
//       iCGST: item.cgstId,
//       iIGST: item.igstId,
//       iTCS: item.tcsId,
//       strSGST: item.sgstDesc,
//       strCGST: item.cgstDesc,
//       strIGST: item.igstDesc,
//       strTCS: item.tcsDesc,
//       strSGSTPer: item.sgstPer,
//       strCGSTPer: item.cgstPer,
//       strIGSTPer: item.igstPer,
//       strTCSPer: item.tcstPer,
//       TaxLvl: item.taxLvl,
//       taxableOn: item.taxableOn,
//       TcsTaxRelId: item.tcsTaxRelId,
//       totalVal: item.netAmt,
//       iIndex: Index,
//       IsNewItem: 1,
//       CashDiscPer: 0,
//       CashDiscAmt: 0,
//       CashDiscValue: 0,
//       BillDiscValue: 0,
//       Value1: 0,
//       Value2: 0,
//       Value3: 0,
//       TotSqureValue: 0,
//       ConstantValue: 0,
//       FinalValue: 0,
//       SACCode: "",
//       SerId: 0,
//       SerCode: "",
//       SerName: "",
//       Remark1: "",
//       Remark2: "",
//       Remark3: "",
//       Remark4: "",
//       RowStatus: 0,
//       IsSerProduct: 0,
//       InvDTId: item.invDTId,
//       IsConvertable: false,
//       ConvertedQty: 0,
//       RowId: item.rowId,
//       Reason: "",
//       DecimalQty: item.decimalQty,
//       StockMaintain: item.stockMaintain,
//       isChecked: item.isChecked === true,
//       YearId: Number(_AuthParems.Year),
//       BranchId: Number(_AuthParems.Branch),
//     }));
//     setarrEntProduct(TransDT);
//   };

//   // ---------- row editing (immutable updates => React re-renders correctly) ----------
//   const toggleRow = (idx) => {
//     setarrEntProduct((prev) =>
//       prev.map((p, i) => (i === idx ? { ...p, isChecked: !p.isChecked } : p))
//     );
//   };
//   const toggleAll = (checked) => {
//     setarrEntProduct((prev) =>
//       prev.map((p) => ({ ...p, isChecked: checked }))
//     );
//   };
//   const changeQty = (idx, raw) => {
//     setarrEntProduct((prev) =>
//       prev.map((p, i) => {
//         if (i !== idx) return p;
//         let q = raw === "" ? "" : toNum(raw);
//         if (q !== "") {
//           if (q < 0) q = 0;
//           if (q > p.MaxQty) q = p.MaxQty; // cannot return more than eligible
//           if (!p.DecimalQty) q = Math.floor(q); // whole-unit products
//         }
//         const ratio = p.MaxQty > 0 ? toNum(q) / p.MaxQty : 0;
//         return {
//           ...p,
//           Qty: q,
//           GoodsValue: toNum(q) * toNum(p.RateWithoutTax),
//           ItemDiscValue: p.OrigDiscValue * ratio,
//           totalVal: p.OrigNetAmt * ratio,
//         };
//       })
//     );
//   };

//   const selectedRows = arrEntProduct.filter((p) => p.isChecked === true);
//   const allChecked =
//     arrEntProduct.length > 0 && selectedRows.length === arrEntProduct.length;
//   const selectedTotal = selectedRows.reduce(
//     (s, p) => s + toNum(p.totalVal),
//     0
//   );

//   const View_ReturnProduct = async () => {
//     if (busyRef.current) return; // block double click
//     try {
//       // ---------- validations ----------
//       if (selectedRows.length === 0) {
//         Show_Message(dispatch, "Select at least one item to return.", "info");
//         return;
//       }
//       const bad = selectedRows.find((p) => toNum(p.Qty) <= 0);
//       if (bad) {
//         Show_Message(
//           dispatch,
//           `Enter a return quantity for ${bad.ProName}.`,
//           "info"
//         );
//         return;
//       }
//       const Party = arrEntCust[0];
//       if (!Party) {
//         Show_Message(dispatch, "Customer details not found for this bill.", "error");
//         return;
//       }

//       busyRef.current = true;
//       Pre_Loading(dispatch, true);
//       const TransDT = selectedRows.map((p) => {
//         const r = { ...p, Qty: toNum(p.Qty) };
//         // popup-only helpers must not travel into the cart / save payload
//         delete r.MaxQty;
//         delete r.OrigDiscValue;
//         delete r.OrigNetAmt;
//         return r;
//       });
//       // tax basis comes from the POS session (Transstates), not the legacy slice
//       const PosCfg = { ..._Pos, iTaxCalcOnId: Number(_Common.iTaxCalcOnId) || 0 };
//       let result = await Calculation(
//         TransDT,
//         _Data.arrEntAL || [],
//         PosCfg,
//         _Disc,
//         _Service.EntALTax
//       );
//       // Calculation() swallows its own errors (alert) and returns undefined
//       if (!result) return;
//       const summary = result.Summary;
//       // Calculation works on PascalCase keys; the grid / save payload use the
//       // camelCase shape that the server returns (proName, qty, taxPer ...)
//       const camel = (o) =>
//         Object.fromEntries(
//           Object.entries(o || {}).map(([k, v]) => [camelKey(k), v])
//         );
//       dispatch(
//         Select_ReturnProduct({
//           EntDT: (result.EntItems || []).map(camel),
//           EntTaxDT: (result.TaxGroup || []).map(camel),
//           EntALDT: result.EntAddLess || [],
//           Summary: {
//             netAmt: summary.NetAmt,
//             qty: summary.Qty,
//             totalDiscount: summary.TotalDiscount,
//             goodsValue: summary.GoodsValue,
//             totalTax: summary.TotalTax,
//             totalAddLess: summary.TotalAddLess,
//             totalTCSTax: summary.TotalTCSTax,
//             roundOff: summary.RoundOff,
//           },
//         })
//       );
//       // header + customer of the NEW return voucher (iVouchId stays 0 => insert)
//       const hdr = [
//         ["iPartyId", Number(Party.iCustId) || 0],
//         ["strPartyName", Party.strCustName || ""],
//         ["iTaxRelId", Number(Party.taxRelId) || 0],
//         ["strPartyDCVouch", TransDT[0].VouchNo || ""],
//         ["iVouchId", 0],
//       ];
//       hdr.forEach(([Name, Value]) => dispatch(Input_Onchange({ Name, Value })));
//       [
//         ["PartyId", Number(Party.iCustId) || 0],
//         ["PartyName", Party.strCustName || ""],
//         ["Mobile", Party.strMobile1 || ""],
//         ["GST", Party.strGST || ""],
//       ].forEach(([Name, Value]) =>
//         dispatch(CustomerInput_Onchange({ Name, Value }))
//       );
//       dispatch(
//         setothercharges({
//           SerId: 0,
//           ServiceName: "",
//           SerCode: "",
//           SACcode: "",
//           bUpdateStatus: false,
//           iRowIndex: 0,
//           RateWithoutTax: (0).toFixed(2),
//           RateWithTax: (0).toFixed(2),
//           dTaxPer: 0,
//           EntALTax: arrEntService,
//         })
//       );
//       props.View_Return(arrEntPermission);
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       busyRef.current = false;
//       Pre_Loading(dispatch, false);
//     }
//   };

//   return (
//     <div className="popup-container">
//       <div className="popup-content">
//         <div className="popup-header">
//           <h5>POS Return</h5>
//           <div className="icon-popup-btn-grp">
//             <span className="icon-btn" onClick={props.Close}>
//               <i className="fa-regular fa-rectangle-xmark"></i>
//             </span>
//           </div>
//         </div>
//         <div className="popup-body p-2">
//           <div className="pos-view">
//             <div className="pos-itemlist">
//               <table className="product-table">
//                 <thead>
//                   <tr>
//                     <th style={{ maxWidth: "50px" }}>
//                       <input
//                         type="checkbox"
//                         className="form-check"
//                         title="Select all"
//                         checked={allChecked}
//                         onChange={(e) => toggleAll(e.target.checked)}
//                       />
//                     </th>
//                     <th>Vouch No</th>
//                     <th>Vouch Date</th>
//                     <th>Product Name</th>
//                     <th>Sold Qty</th>
//                     <th>Return Qty</th>
//                     <th>Net Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {isLoaded && arrEntProduct.length === 0 && (
//                     <tr>
//                       <td colSpan={7} style={{ textAlign: "center" }}>
//                         No items eligible for return on this bill.
//                       </td>
//                     </tr>
//                   )}
//                   {arrEntProduct.map((product, trIndex) => (
//                     <tr key={product.RowId ?? trIndex}>
//                       <td style={{ maxWidth: "50px" }}>
//                         <input
//                           type="checkbox"
//                           className="form-check"
//                           checked={product.isChecked === true}
//                           onChange={() => toggleRow(trIndex)}
//                         />
//                       </td>
//                       <td style={{ textAlign: "center" }}>{product.VouchNo}</td>
//                       <td style={{ textAlign: "center" }}>
//                         {product.VouchDate}
//                       </td>
//                       <td style={{ textAlign: "left" }}>
//                         {product.ProName}
//                         <sub style={{ marginLeft: "10px" }}>
//                           {(product.AttValues || "").replace(/\//g, "-")}
//                         </sub>
//                         <br />
//                         <span>
//                           GST - {money(product.TaxPer)} % | Unit :
//                           {product.UnitName}
//                         </span>
//                       </td>
//                       <td style={{ textAlign: "center" }}>{product.MaxQty}</td>
//                       <td style={{ textAlign: "center", maxWidth: "90px" }}>
//                         <input
//                           type="number"
//                           className="form-control"
//                           min={0}
//                           max={product.MaxQty}
//                           step={product.DecimalQty ? "0.01" : "1"}
//                           value={product.Qty}
//                           disabled={!product.isChecked}
//                           onChange={(e) => changeQty(trIndex, e.target.value)}
//                           onFocus={(e) => e.target.select()}
//                         />
//                       </td>
//                       <td style={{ textAlign: "right" }}>
//                         {money(product.totalVal)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//                 {selectedRows.length > 0 && (
//                   <tfoot>
//                     <tr>
//                       <td colSpan={6} style={{ textAlign: "right" }}>
//                         <b>Selected: {selectedRows.length}</b>
//                       </td>
//                       <td style={{ textAlign: "right" }}>
//                         <b>{money(selectedTotal)}</b>
//                       </td>
//                     </tr>
//                   </tfoot>
//                 )}
//               </table>
//             </div>
//           </div>
//         </div>
//         <div className="pos-btn-group">
//           <div
//             className="pos-tooltip"
//             onClick={() => View_ReturnProduct()}
//             style={{ opacity: selectedRows.length ? 1 : 0.5 }}
//           >
//             <a className="icon-btn" href="##" onClick={(e) => e.preventDefault()}>
//               <i className="fa-solid fa-arrow-rotate-left"></i>
//             </a>
//             <span className="pos-tooltiptxt">Return</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProductReturn;





import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { setothercharges } from "../features/POS";
import {
  CustomerInput_Onchange,
  Input_Onchange,
  Select_ReturnProduct,
} from "../features/Transactionstates";
import Calculation from "./Calculation";
import { API_FETCH } from "../General/Utility";
import { fnMoneyRound, num } from "../General/Utility";

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const money = (v) => toNum(v).toFixed(2);
const r2 = (v) => fnMoneyRound(v, 0.01);
// Keeps the JSON type the server sent for a field: the API models bind with
// System.Text.Json, which rejects a number for a string property (and vice
// versa) with HTTP 400 "Please Verify the Values Data Type".
const asType = (orig, value) => {
  if (typeof orig === "string") return toNum(value).toFixed(2);
  if (typeof orig === "boolean") return toNum(value) !== 0;
  return value;
};
// reads a server field whatever casing the JSON uses (itemAmt / ItemAmt)
const fv = (o, name) => {
  if (!o) return undefined;
  if (o[name] !== undefined) return o[name];
  const pas = name.charAt(0).toUpperCase() + name.slice(1);
  if (o[pas] !== undefined) return o[pas];
  const cam = name.charAt(0).toLowerCase() + name.slice(1);
  return o[cam];
};
// Original bill (POS/View_VoucherDetails) reduced to what a return needs:
// every line's ORIGINAL qty and amounts (bill discount already inside them) and
// the bill's other-charge rows. A return is priced as a share of these, so a
// full return refunds exactly the billed amount and a partial one its share.
const fnBuildBillBasis = (res) => {
  if (!res || !Array.isArray(res.objEntDT)) return null;
  const dt = {};
  let itemsAmt = 0;
  res.objEntDT.forEach((l) => {
    const id = toNum(fv(l, "invDTId") ?? fv(l, "posInvDTId"));
    const row = {
      qty: toNum(fv(l, "qty")),
      goodsValue: toNum(fv(l, "goodsValue")),
      itemDiscValue: toNum(fv(l, "itemDiscValue")),
      cashDiscValue: toNum(fv(l, "cashDiscValue")),
      billDiscValue: toNum(fv(l, "billDiscValue")),
      taxableAmt: toNum(fv(l, "taxableAmt")),
      taxAmt: toNum(fv(l, "taxAmt")),
      itemAmt: toNum(fv(l, "itemAmt")),
    };
    itemsAmt += row.itemAmt;
    if (id > 0) dt[id] = row;
  });
  const al = (Array.isArray(res.objEntALDT) ? res.objEntALDT : []).filter(
    (a) => toNum(fv(a, "serId")) > 0
  );
  return {
    dt,
    itemsAmt: r2(itemsAmt),
    al,
    alTaxable: r2(al.reduce((t, a) => t + toNum(fv(a, "taxableAmt")), 0)),
    alTax: r2(al.reduce((t, a) => t + toNum(fv(a, "taxAmt")), 0)),
    alAmt: r2(al.reduce((t, a) => t + toNum(fv(a, "itemAmt")), 0)),
  };
};
// share of the bill's other charges that belongs to the returned items
const fnALShare = (basis, returnedItemsAmt) => {
  if (!basis || basis.itemsAmt <= 0 || basis.al.length === 0) return 0;
  const k = toNum(returnedItemsAmt) / basis.itemsAmt;
  return k <= 0 ? 0 : k >= 0.99995 ? 1 : k;
};
// round-off unit of the POS config (T4); nearest rupee when not set
const fnRoundUnit = (Pos) => {
  const u = num(Pos && Pos.AutoRoundOff);
  return u > 0 && u <= 100 ? u : 1;
};
// Same rule System.Text.Json uses for the server's camelCase output
// (SNo -> sNo, SACCode -> sacCode, ProName -> proName, FQty -> fQty), so rows created
// here have exactly the keys of rows opened from the server (grid, edit, save).
const camelKey = (k) => {
  if (!k || !/[A-Z]/.test(k[0])) return k;
  const c = k.split("");
  for (let i = 0; i < c.length; i++) {
    if (i === 1 && !/[A-Z]/.test(c[1])) break;
    if (i > 0 && i + 1 < c.length && !/[A-Z]/.test(c[i + 1])) break;
    c[i] = c[i].toLowerCase();
  }
  return c.join("");
};

function ProductReturn(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const [arrEntPermission, setarrEntPermission] = useState([]);
  const [arrEntProduct, setarrEntProduct] = useState([]);
  const [arrEntCust, setarrEntCust] = useState([]);
  const [arrEntService, setarrEntService] = useState([]);
  const [isLoaded, setisLoaded] = useState(false);
  const busyRef = useRef(false);
  const billRef = useRef(null); // original bill basis (fnBuildBillBasis)
  const closeRef = useRef(props.Close);
  closeRef.current = props.Close;

  //#region  Readonly Parem from Global Redux Storage
  // The POS screen reads Transstates (Header / Data / Summary / Customer), so the
  // return must be written there. Legacy features/POS only keeps Pos config,
  // BillDiscount and OtherCharges, which Pointofsales.js still uses.
  const _Pos = useSelector((state) => state.Pointofsales.Pos);
  const _Common = useSelector((state) => state.Transstates.Common);
  const _Data = useSelector((state) => state.Transstates.Data);
  // A1: single source of truth for discounts (was the legacy Pointofsales slice)
  const _Disc = useSelector((state) => state.Transstates.Discount);
  const _Service = useSelector((state) => state.Pointofsales.OtherCharges);
  //#endregion

  useEffect(() => {
    Load_PosReturn(props.VouchId);
    // FIX: listener is now removed on unmount (earlier it leaked and every
    // Escape called Close() once per time the popup had ever been opened).
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        if (closeRef.current) closeRef.current();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
    // eslint-disable-next-line
  }, []);

  const Load_PosReturn = async (Vouchid) => {
    try {
      Pre_Loading(dispatch, true);
      // FIX: endpoint is [HttpGet] in POSController - was called with API_POST
      // (and dispatch was passed as the body) => 405 / empty popup.
      // eligible lines + the original bill (amounts / other charges) together
      const [res, resBill] = await Promise.all([
        API_FETCH(`POS/View_ReturnProduct/${Vouchid}/${_AuthParems.DB}`, dispatch),
        API_FETCH(
          `POS/View_VoucherDetails/${Vouchid}/93/${Number(_AuthParems.Branch)}/${_AuthParems.DB}`,
          dispatch
        ).catch(() => null),
      ]);
      billRef.current = fnBuildBillBasis(resBill);
      if (res && res.EntReturn && res.EntReturn.entProduct) {
        setarrEntCust(res.EntReturn.entParty || []);
        setarrEntService(
          (res.EntService && res.EntService._EntServiceTax) || []
        );
        Assign_ReturnProduct(res.EntReturn.entProduct);
        let EntCol = [...(res.EntTableCol || [])].sort(
          (a, b) => a.inOrderTO - b.inOrderTO
        );
        EntCol = EntCol.filter((dt) => dt.isShowInScr === true);
        setarrEntPermission(EntCol);
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    } finally {
      // FIX: loader was never switched off on the success path.
      Pre_Loading(dispatch, false);
      setisLoaded(true);
    }
  };

  const Assign_ReturnProduct = (Returnproduct) => {
    const TransDT = Returnproduct.map((item, Index) => ({
      VouchId: item.vouchId,
      VouchNo: item.vouchNo,
      VouchDate: item.vouchDate,
      SNo: item.sNo,
      ProId: item.proId,
      AttGrpId: item.attGrpId,
      ProCode: item.proCode,
      ProName: item.proName,
      CommodityCode: item.commodityCode,
      AttValues: item.attValues || "",
      UnitId: item.unitId,
      UnitName: item.unitName,
      RateWithoutTax: item.rateWithoutTax,
      RateWithTax: item.rateWithTax,
      dMinMargin: item.minMargin,
      ItemDiscPer: item.itemDiscPer,
      ItemDiscAmt: item.itemDiscAmt,
      ItemDiscValue: item.itemDiscValue,
      Qty: item.qty,
      // ---- used only by this popup (return-qty editing) ----
      MaxQty: toNum(item.qty),
      // ORIGINAL line qty: the amounts below belong to it (MaxQty is what is
      // still returnable after earlier returns)
      OrigLineQty:
        toNum(billRef.current?.dt[toNum(item.invDTId)]?.qty) || toNum(item.qty),
      OrigDiscValue: toNum(item.itemDiscValue),
      // the LINE's own amount (netAmt is the whole bill's NetAmt)
      OrigNetAmt: toNum(item.itemAmt),
      // ------------------------------------------------------
      FQty: 0,
      GoodsValue: item.qty * item.rateWithoutTax,
      TaxableAmt: 0,
      TaxAmt: 0,
      ItemAmt: 0,
      BatchNo: item.batchNo,
      ManufactureDate: item.manufactureDate,
      ExpiryDate: item.expiryDate,
      iTaxRelId: item.taxRelId,
      // the rate the bill was taxed at (not today's product-master rate)
      TaxPer: toNum(item.taxPer) || toNum(item.igstPer),
      iSGST: item.sgstId,
      iCGST: item.cgstId,
      iIGST: item.igstId,
      iTCS: item.tcsId,
      strSGST: item.sgstDesc,
      strCGST: item.cgstDesc,
      strIGST: item.igstDesc,
      strTCS: item.tcsDesc,
      strSGSTPer: item.sgstPer,
      strCGSTPer: item.cgstPer,
      strIGSTPer: item.igstPer,
      strTCSPer: item.tcstPer,
      TaxLvl: item.taxLvl,
      taxableOn: item.taxableOn,
      TcsTaxRelId: item.tcsTaxRelId,
      totalVal: r2(
        (toNum(item.itemAmt) * toNum(item.qty)) /
          (toNum(billRef.current?.dt[toNum(item.invDTId)]?.qty) ||
            toNum(item.qty) ||
            1)
      ),
      iIndex: Index,
      IsNewItem: 1,
      CashDiscPer: 0,
      CashDiscAmt: 0,
      CashDiscValue: 0,
      BillDiscValue: 0,
      Value1: 0,
      Value2: 0,
      Value3: 0,
      TotSqureValue: 0,
      ConstantValue: 0,
      FinalValue: 0,
      SACCode: "",
      SerId: 0,
      SerCode: "",
      SerName: "",
      Remark1: "",
      Remark2: "",
      Remark3: "",
      Remark4: "",
      RowStatus: 0,
      IsSerProduct: 0,
      InvDTId: item.invDTId,
      IsConvertable: false,
      ConvertedQty: 0,
      RowId: item.rowId,
      Reason: "",
      DecimalQty: item.decimalQty,
      StockMaintain: item.stockMaintain,
      isChecked: item.isChecked === true,
      YearId: Number(_AuthParems.Year),
      BranchId: Number(_AuthParems.Branch),
    }));
    setarrEntProduct(TransDT);
  };

  // ---------- row editing (immutable updates => React re-renders correctly) ----------
  const toggleRow = (idx) => {
    setarrEntProduct((prev) =>
      prev.map((p, i) => (i === idx ? { ...p, isChecked: !p.isChecked } : p))
    );
  };
  const toggleAll = (checked) => {
    setarrEntProduct((prev) =>
      prev.map((p) => ({ ...p, isChecked: checked }))
    );
  };
  const changeQty = (idx, raw) => {
    setarrEntProduct((prev) =>
      prev.map((p, i) => {
        if (i !== idx) return p;
        let q = raw === "" ? "" : toNum(raw);
        if (q !== "") {
          if (q < 0) q = 0;
          if (q > p.MaxQty) q = p.MaxQty; // cannot return more than eligible
          if (!p.DecimalQty) q = Math.floor(q); // whole-unit products
        }
        // share of the ORIGINAL line (not of the remaining qty)
        const base = toNum(p.OrigLineQty) || toNum(p.MaxQty);
        const ratio = base > 0 ? toNum(q) / base : 0;
        return {
          ...p,
          Qty: q,
          GoodsValue: r2(toNum(q) * toNum(p.RateWithoutTax)),
          ItemDiscValue: r2(p.OrigDiscValue * ratio),
          totalVal: r2(p.OrigNetAmt * ratio),
        };
      })
    );
  };

  const selectedRows = arrEntProduct.filter((p) => p.isChecked === true);
  const allChecked =
    arrEntProduct.length > 0 && selectedRows.length === arrEntProduct.length;
  // refund preview = returned items + their share of the bill's other charges,
  // rounded like the invoice (Bill 26 full return: 6092.80 -> 6093.00)
  const selectedItemsAmt = r2(
    selectedRows.reduce((t, p) => t + toNum(p.totalVal), 0)
  );
  const selectedTotal = fnMoneyRound(
    selectedItemsAmt +
      r2(
        toNum(billRef.current?.alAmt) *
          fnALShare(billRef.current, selectedItemsAmt)
      ),
    fnRoundUnit(_Pos)
  );

  const View_ReturnProduct = async () => {
    if (busyRef.current) return; // block double click
    try {
      // ---------- validations ----------
      if (selectedRows.length === 0) {
        Show_Message(dispatch, "Select at least one item to return.", "info");
        return;
      }
      const bad = selectedRows.find((p) => toNum(p.Qty) <= 0);
      if (bad) {
        Show_Message(
          dispatch,
          `Enter a return quantity for ${bad.ProName}.`,
          "info"
        );
        return;
      }
      const Party = arrEntCust[0];
      if (!Party) {
        Show_Message(dispatch, "Customer details not found for this bill.", "error");
        return;
      }

      busyRef.current = true;
      Pre_Loading(dispatch, true);
      const TransDT = selectedRows.map((p) => {
        const r = { ...p, Qty: toNum(p.Qty) };
        // popup-only helpers must not travel into the cart / save payload
        delete r.MaxQty;
        delete r.OrigDiscValue;
        delete r.OrigNetAmt;
        delete r.OrigLineQty;
        return r;
      });
      // tax basis comes from the POS session (Transstates), not the legacy slice
      const PosCfg = { ..._Pos, iTaxCalcOnId: Number(_Common.iTaxCalcOnId) || 0 };
      // A1: a refund is priced ONLY from the original bill lines. The current
      // cart's bill discount / coupon / reward / other charges must never be
      // applied to it. Keys of BOTH discount slices are zeroed so Calculation()
      // reads zeros whichever shape it expects.
      const ReturnDisc = {
        ...(_Disc || {}),
        dBillDisPer: 0,
        dBillDisAmt: 0,
        dBillDisValue: 0,
        dALBillDisPer: 0,
        dALBillDisAmt: 0,
        dALBillDisValue: 0,
        dCouponDiscPer: 0,
        dCouponDiscAmt: 0,
        dRewardPointper: 0,
        dRewardPointAmt: 0,
        iCouponId: 0,
        strCoupon: "",
        strCouponCode: "",
        iALBillDiscId: num(_Common.iALBillDiscId),
      };
      let result = await Calculation(
        TransDT,
        [],
        PosCfg,
        ReturnDisc,
        _Service.EntALTax
      );
      if (!result || !result.Summary || !Array.isArray(result.EntItems)) {
        Show_Message(
          dispatch,
          "Unable to calculate the return. Please review the selected quantities and retry.",
          "error"
        );
        return;
      }
      const summary = result.Summary;
      // ---- reconcile the return with the ORIGINAL bill (commercial standard) ----
      // Calculation() re-prices lines from rate x qty without the bill's discount
      // and other charges. Each returned line is set to its exact share of the
      // original line (bill discount included), the bill's other charges are
      // returned in proportion, and the total is rounded like the invoice.
      const basis = billRef.current;
      let EntItems = result.EntItems || [];
      let TaxGroup = result.TaxGroup || [];
      let EntALDT = result.EntAddLess || [];
      if (basis) {
        let calcTaxable = 0;
        let calcTax = 0;
        let corrTaxable = 0;
        let corrTax = 0;
        EntItems = EntItems.map((it, idx) => {
          calcTaxable += toNum(fv(it, "TaxableAmt"));
          calcTax += toNum(fv(it, "TaxAmt"));
          const id = toNum(fv(it, "InvDTId")) || toNum(TransDT[idx]?.InvDTId);
          const o = basis.dt[id];
          if (!o || o.qty <= 0) {
            corrTaxable += toNum(fv(it, "TaxableAmt"));
            corrTax += toNum(fv(it, "TaxAmt"));
            return it;
          }
          const f = toNum(fv(it, "Qty") ?? TransDT[idx]?.Qty) / o.qty;
          const vals = {
            GoodsValue: r2(o.goodsValue * f),
            ItemDiscValue: r2(o.itemDiscValue * f),
            CashDiscValue: r2(o.cashDiscValue * f),
            BillDiscValue: r2(o.billDiscValue * f),
            TaxableAmt: r2(o.taxableAmt * f),
            TaxAmt: r2(o.taxAmt * f),
            ItemAmt: r2(o.itemAmt * f),
          };
          corrTaxable += vals.TaxableAmt;
          corrTax += vals.TaxAmt;
          const line = { ...it };
          // only fields the line already has (unknown keys / types never reach the API)
          Object.keys(vals).forEach((k) => {
            if (k in line) line[k] = asType(it[k], vals[k]);
          });
          return line;
        });
        // tax summary rows follow the corrected lines
        const kTaxable = calcTaxable > 0 ? corrTaxable / calcTaxable : 1;
        const kTax = calcTax > 0 ? corrTax / calcTax : 1;
        TaxGroup = TaxGroup.map((g) => ({
          ...g,
          TaxableAmt: asType(g.TaxableAmt, r2(toNum(fv(g, "TaxableAmt")) * kTaxable)),
          TaxAmt: asType(g.TaxAmt, r2(toNum(fv(g, "TaxAmt")) * kTax)),
        }));
        // other charges in proportion to the returned item value
        const itemsAmt = r2(EntItems.reduce((t, it) => t + toNum(fv(it, "ItemAmt")), 0));
        const k = fnALShare(basis, itemsAmt);
        EntALDT =
          k > 0
            ? basis.al.map((a, idx) => {
                const row = { ...a };
                // a NEW return row: no ids of the invoice's rows
                if ("alId" in row) row.alId = asType(row.alId, 0);
                if ("id" in row) row.id = asType(row.id, 0);
                if ("sNo" in row) row.sNo = asType(row.sNo, idx + 1);
                if ("isNewItem" in row) row.isNewItem = asType(row.isNewItem, 1);
                ["rateWithoutTax", "rateWithTax", "taxableAmt", "taxAmt", "itemAmt"].forEach(
                  (key) => {
                    if (key in row) row[key] = asType(row[key], r2(toNum(row[key]) * k));
                  }
                );
                return row;
              })
            : [];
        const alTaxable = r2(EntALDT.reduce((t, a) => t + toNum(a.taxableAmt), 0));
        const alTax = r2(EntALDT.reduce((t, a) => t + toNum(a.taxAmt), 0));
        const alAmt = r2(EntALDT.reduce((t, a) => t + toNum(a.itemAmt), 0));
        summary.GoodsValue = r2(EntItems.reduce((t, it) => t + toNum(fv(it, "GoodsValue")), 0));
        summary.TotalDiscount = r2(
          EntItems.reduce(
            (t, it) =>
              t +
              toNum(fv(it, "ItemDiscValue")) +
              toNum(fv(it, "CashDiscValue")) +
              toNum(fv(it, "BillDiscValue")),
            0
          )
        );
        summary.TotalTax = r2(corrTax + alTax);
        summary.TotalAddLess = alTaxable;
        // amount before round-off = items (tax + discounts inside) + other charges
        summary.NetAmt = r2(itemsAmt + alAmt);
        summary.RoundOff = 0;
      }
      // Round-off: same commercial rule as the invoice (nearest unit, half away
      // from zero), in paise so a float artefact can never shift it.
      // Bill 26 full return: 6092.80 -> 6093.00 (+0.20), exactly what was billed.
      {
        const dBeforeRound = r2(num(summary.NetAmt) - num(summary.RoundOff));
        const dNet = fnMoneyRound(dBeforeRound, fnRoundUnit(_Pos));
        summary.RoundOff = r2(dNet - dBeforeRound);
        summary.NetAmt = dNet;
      }
      // Calculation works on PascalCase keys; the grid / save payload use the
      // camelCase shape that the server returns (proName, qty, taxPer ...)
      const camel = (o) =>
        Object.fromEntries(
          Object.entries(o || {}).map(([k, v]) => [camelKey(k), v])
        );
      dispatch(
        Select_ReturnProduct({
          EntDT: EntItems.map(camel),
          EntTaxDT: TaxGroup.map(camel),
          EntALDT: EntALDT,
          Summary: {
            netAmt: summary.NetAmt,
            qty: summary.Qty,
            totalDiscount: summary.TotalDiscount,
            goodsValue: summary.GoodsValue,
            totalTax: summary.TotalTax,
            totalAddLess: summary.TotalAddLess,
            totalTCSTax: summary.TotalTCSTax,
            roundOff: summary.RoundOff,
          },
        })
      );
      // header + customer of the NEW return voucher (iVouchId stays 0 => insert)
      const hdr = [
        ["iPartyId", Number(Party.iCustId) || 0],
        ["strPartyName", Party.strCustName || ""],
        ["iTaxRelId", Number(Party.taxRelId) || 0],
        ["strPartyDCVouch", TransDT[0].VouchNo || ""],
        ["iVouchId", 0],
      ];
      hdr.forEach(([Name, Value]) => dispatch(Input_Onchange({ Name, Value })));
      [
        ["PartyId", Number(Party.iCustId) || 0],
        ["PartyName", Party.strCustName || ""],
        ["Mobile", Party.strMobile1 || ""],
        ["GST", Party.strGST || ""],
      ].forEach(([Name, Value]) =>
        dispatch(CustomerInput_Onchange({ Name, Value }))
      );
      dispatch(
        setothercharges({
          SerId: 0,
          ServiceName: "",
          SerCode: "",
          SACcode: "",
          bUpdateStatus: false,
          iRowIndex: 0,
          RateWithoutTax: (0).toFixed(2),
          RateWithTax: (0).toFixed(2),
          dTaxPer: 0,
          EntALTax: arrEntService,
        })
      );
      props.View_Return(arrEntPermission);
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    } finally {
      busyRef.current = false;
      Pre_Loading(dispatch, false);
    }
  };

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>POS Return</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={props.Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body p-2">
          <div className="pos-view">
            <div className="pos-itemlist">
              <table className="product-table">
                <thead>
                  <tr>
                    <th style={{ maxWidth: "50px" }}>
                      <input
                        type="checkbox"
                        className="form-check"
                        title="Select all"
                        checked={allChecked}
                        onChange={(e) => toggleAll(e.target.checked)}
                      />
                    </th>
                    <th>Vouch No</th>
                    <th>Vouch Date</th>
                    <th>Product Name</th>
                    <th>Sold Qty</th>
                    <th>Return Qty</th>
                    <th>Net Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoaded && arrEntProduct.length === 0 && (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No items eligible for return on this bill.
                      </td>
                    </tr>
                  )}
                  {arrEntProduct.map((product, trIndex) => (
                    <tr key={product.RowId ?? trIndex}>
                      <td style={{ maxWidth: "50px" }}>
                        <input
                          type="checkbox"
                          className="form-check"
                          checked={product.isChecked === true}
                          onChange={() => toggleRow(trIndex)}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>{product.VouchNo}</td>
                      <td style={{ textAlign: "center" }}>
                        {product.VouchDate}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {product.ProName}
                        <sub style={{ marginLeft: "10px" }}>
                          {(product.AttValues || "").replace(/\//g, "-")}
                        </sub>
                        <br />
                        <span>
                          GST - {money(product.TaxPer)} % | Unit :
                          {product.UnitName}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>{product.MaxQty}</td>
                      <td style={{ textAlign: "center", maxWidth: "90px" }}>
                        <input
                          type="number"
                          className="form-control"
                          min={0}
                          max={product.MaxQty}
                          step={product.DecimalQty ? "0.01" : "1"}
                          value={product.Qty}
                          disabled={!product.isChecked}
                          onChange={(e) => changeQty(trIndex, e.target.value)}
                          onFocus={(e) => e.target.select()}
                        />
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {money(product.totalVal)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {selectedRows.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        <b>Selected: {selectedRows.length}</b>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <b>{money(selectedTotal)}</b>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </div>
        <div className="pos-btn-group">
          <div
            className="pos-tooltip"
            onClick={() => View_ReturnProduct()}
            style={{ opacity: selectedRows.length ? 1 : 0.5 }}
          >
            <a className="icon-btn" href="##" onClick={(e) => e.preventDefault()}>
              <i className="fa-solid fa-arrow-rotate-left"></i>
            </a>
            <span className="pos-tooltiptxt">Return</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductReturn;